import { useLocation } from 'react-router-dom';

export const updateQueryStringParameter = (uri: string, key: string, value: string) => {
  const re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
  const separator = uri.indexOf('?') !== -1 ? '&' : '?';
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + '=' + value + '$2');
  } else {
    return uri + separator + key + '=' + value;
  }
};

export const publicUrl = (path: string) => {
  const publicUrl = process.env.PUBLIC_URL!.endsWith('/')
    ? process.env.PUBLIC_URL
    : `${process.env.PUBLIC_URL}/`;

  const normalizedPath = path.startsWith('/') ? path.substring(1) : path;
  return `${publicUrl}${normalizedPath}`;
};

export const trimSlashes = (path: string) => {
  let fixedPath = path;
  if (fixedPath[0] === '/') {
    fixedPath = fixedPath.substring(1);
  }
  if (fixedPath[fixedPath.length - 1] === '/') {
    fixedPath = fixedPath.substring(0, fixedPath.length - 1);
  }
  return fixedPath;
};

/**
 * Transforms a string to be a valid part URI path
 *
 * "My Path Name" => "my-path-name"
 *
 * @param value string to be transformed
 */
export const stringToURI = (value: string) => {
  // lets not encode spaces as %20, use hyphens instead
  const noSpaces = value.toLowerCase().replace(/\s/g, '-');
  return encodeURI(noSpaces);
};

export function usePatternRouteMatch(patterns: string[]) {
  const { pathname } = useLocation();
  const parts = pathname.split('/').filter((part) => part !== '');
  const lastPart = `${parts[parts.length - 1]}`;

  const foundIndex = patterns.findIndex((pattern) => pattern === lastPart);
  return foundIndex > -1 ? patterns[foundIndex] : null;
}

export function usePatternIncludedRouteMatch(patterns: string[]) {
  const { pathname } = useLocation();
  const parts = pathname.split('/').filter((part) => part !== '');

  const found = patterns.find((pattern) => parts.includes(pattern));
  return found || null;
}

export const trimLastSlash = (path: string) => {
  if (path.endsWith('/')) {
    return path.slice(0, -1);
  }
  return path;
};
